import { useQuery } from '@tanstack/react-query';
import { getSelfRequest } from '@models/user.model';
import { getSelf } from '@services/currentUser';
import { getOrganizationId } from '@config/storage';

export const USER_CURRENT_QUERY_KEY = ['currentUser'];

export const useCurrentUser = (options?: { enabled?: boolean }) => {
  // Include organizationId in query key to ensure cache is invalidated when switching organizations
  const organizationId = getOrganizationId();

  return useQuery<getSelfRequest>({
    queryKey: [...USER_CURRENT_QUERY_KEY, organizationId],
    queryFn: getSelf,
    staleTime: 5 * 60 * 1000,
    enabled: options?.enabled !== false,
  });
};

export default useCurrentUser;
